import { useSelector } from 'react-redux';
import { LoginState } from '../state/loginSlice';
import { RootState } from '../App';

export const useLoginState = () => {
	const state: LoginState = useSelector<RootState, LoginState>(state => state.login);
	return state;
};
